module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zLjM1NDQ2IDIwLjY3NTNMMTEuODU0NSAxMi4xNzUzTDIwLjM1NDUgMjAuNjc1M00yMC4zNTQ1IDMuNjc1MjlMMTEuODUyOCAxMi4xNzUzTDMuMzU0NDYgMy42NzUyOSIgc3Ryb2tlPSIjNTU1NTU1IiBzdHJva2Utd2lkdGg9IjUuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/close.svg
// module id = d3CT
// module chunks = 0